import { BitrixVue } from 'ui.vue';
import { Vuex } from 'ui.vue.vuex';
import KeenUI from 'keen-ui';
import Skeleton from 'vue-loading-skeleton';

import './components/main/main';
/*
 * теперь этот файл/поток будет кодироваться в UTF-8
 */

BitrixVue.use(KeenUI);
BitrixVue.use(Skeleton);

export class Configurator {
	#vm;
	constructor(nodeId = 'root', params = {}) {
		this.rootNode = document.querySelector(nodeId);
		this.options = params;
		this.attachTemplate();
	}
	attachTemplate() {
		const context = this;
		const store = Vuex.createStore({
			state: {
				position: {},
				totalAmount: 0,
				positionPrice: 0,
				basket: [],
				previewDoor: null,
				basketChange: false,
				imageLoading: false,
				clearRenderImageCache: false,
			},
			actions: {
				setPosition(store, prop) {
					store.commit('setPosition', prop);
				},
				setBasketPos(store, basket) {
					store.commit('setBasketPos', basket);
				},
				setPositionPrice(store, price) {
					store.commit('setPositionPrice', price);
				},
				setTotalAmount(store, amount) {
					store.commit('setTotalAmount', amount);
				},
				setPositionBasket(store) {
					store.commit('setPositionBasket');
				},
				removeFromBasket(store, basketId) {
					store.commit('removeFromBasket', basketId);
				},
				renameDoorName(store, params) {
					store.commit('renameDoorName', params);
				},
				setPreviewDoor(store, params) {
					store.commit('setPreviewDoor', params);
				},
				setCopyDoor(store, basketId) {
					store.commit('setCopyDoor', basketId);
				},
				setBasketChange(store, flag) {
					store.commit('setBasketChange', flag);
				},
				deleteKeyFromPosition(store, keysArray) {
					store.commit('deleteKeyFromPosition', keysArray);
				},
				setImageLoadingStatus(store, flag) {
					store.commit('setImageLoadingStatus', flag);
				},
				calculateDoorNacenka(store) {
					store.commit('calculateDoorNacenka');
				},
				setClearRenderImageCache(store, flag) {
					store.commit('setClearRenderImageCache', flag);
				},
			},
			mutations: {
				calculateDoorNacenka(state) {
					const position = state.position;
					const nacenki = state.position?.forNacenka;
					if (nacenki === undefined) return;
					const nacenka = nacenki.filter((item) => {
						if (item.width === position.doorTypeCanvasWidth && item.height === position.doorTypeCanvasHeight) return item;
					});
					if (!nacenka.length) {
						state.position.doorSizePrice = { price: 0 };
						return;
					}
					state.position.doorSizePrice = { price: 0 };
					const nacenkaColor = position.doorCover.price_nacenka_pogonag ? position.doorCover.price + position.doorCover.price_nacenka_pogonag / 100 : position.doorCover.price;
					const priceWithNacenka = (position.door.price + nacenkaColor) * nacenka[0].price;

					state.position.doorSizePrice = { price: Math.floor(priceWithNacenka) };
				},
				setImageLoadingStatus(state, flag) {
					state.imageLoading = flag;
				},
				setBasketChange(state, flag) {
					state.basketChange = flag;
				},

				deleteKeyFromPosition(state, keys) {
					keys.forEach((key) => {
						if (state.position.hasOwnProperty(key)) {
							delete state.position[key];
						}
					});
				},
				setPositionPrice(state, price) {
					state.positionPrice = price;
				},
				setBasketPos(state, basket) {
					state.basket = basket;
				},
				setTotalAmount(state, amount) {
					state.totalAmount = amount;
				},
				setClearRenderImageCache(state, flag) {
					state.clearRenderImageCache = flag;
				},

				setPositionBasket(state) {
					state.position.totalAmount = state.positionPrice;
					state.position.positionDoorName = state.basket.length ? `Дверь ${state.basket.length + 1}` : `Дверь ${1}`;
					state.basket = [...state.basket, state.position];

					let price = 0;
					for (const key in state.basket) {
						if (Object.hasOwnProperty.call(state.basket, key)) {
							const element = state.basket[key];
							if (element?.totalAmount) {
								price += element.totalAmount;
							}
						}
					}
					state.totalAmount = price;

					state.positionPrice = 0;
					state.position = {};
					state.clearRenderImageCache = true;
				},
				setPosition(state, prop) {

					state.position = {
						...state.position,
						...prop,
					};

					let price = 0;
					const values = Object.values(state.position);
					values.forEach((value) => {
						if (value !== undefined && value !== null && value.price !== undefined) {
							price += value.price;
						}
					});

					state.positionPrice = price;
				},
				removeFromBasket(state, basketId) {
					state.basket.forEach((item, index) => {
						if (index === basketId) state.basket.splice(index, 1);
					});
				},
				setCopyDoor(state, basketId) {
					let copiedDoor = null;
					state.basket.forEach((item, index) => {
						if (index === basketId) copiedDoor = state.basket[index];
					});
					copiedDoor.positionDoorName = 'Дверь ' + (state.basket.length + 1);
					state.basket.push(copiedDoor);
					let total = state.basket.reduce((acc, curr) => {
						return (acc += curr.totalAmount);
					}, 0);
					state.totalAmount = total;
				},
				renameDoorName(state, params) {
					state.basket[params.basketId].positionDoorName = params.doorName;
				},
				setPreviewDoor(state, data) {
					state.previewDoor = data;
				},
			},
		});

		this.#vm = BitrixVue.createApp({
			beforeCreate() {
				this.$bitrix.Application.set(context);
			},
			store,
			template: `<Main/>`,
		}).mount(this.rootNode);
	}
}
